<div class="flex-header">
    <div class="float-left">
        <div class="display-flex back-flex">
            <img src="../../../../assets/images/back_button_popup.svg" (click)="goBack()" alt="Back" />
            <h1>{{ title }}</h1>
            <button [class]="buttonClass" (click)="onButtonClick()">{{ buttonText }}</button>
        </div>
    </div>
</div>

<div class="feedback-details">
    <div class="inner">
        <div class="col">
            <div class="label-text">{{ displayData?.submittedByLabel || 'Submitted by' }}</div>
            <span>{{ displayData?.submittedBy || ((displayData?.given_by_first_name || '') + ' ' +
                (displayData?.given_by_last_name || '')) || 'N/A' }}</span>
        </div>
        <div class="col">
            <div class="label-text">{{ displayData?.submittedOnLabel || 'Submitted on' }}</div>
            <span>{{ formattedDate || 'N/A' }}</span>
        </div>
        <div class="col">
            <div class="label-text">{{ displayData?.statusLabel || 'Status' }}</div>
            <span [class.status-open]="displayData?.status === 'Open'"
                [class.status-in-progress]="displayData?.status === 'In Progress'"
                [class.status-pending]="displayData?.status === 'Pending'"
                [class.status-resolved]="displayData?.status === 'Resolved'"
                [class.status-closed]="displayData?.status === 'Closed'">
                {{ displayData?.status || displayData?.feedback_status || 'Status' }}
            </span>
        </div>
        <div class="col">
            <div class="label-text">{{ displayData?.assigneeLabel || 'Assignee' }}</div>
            <span>{{ displayData?.assigned_category || 'Unassigned' }}</span>
            <a class="edit-link" (click)="onAssignClick()">Edit</a>
        </div>
    </div>
</div>